import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import './LoadingIndicator.scss';

class LoadingIndicator extends React.Component {
    getClassNames = () => {
        // Add classes only when the loading indicator is visible
        if (this.props.isLoading) {
            return this.props.isFullscreen ? "loader-wrapper fullscreen" : "loader-wrapper";
        } else {
            return "";
        }
    };

    render() {
        return (
            <div className={this.getClassNames()}>
                {this.props.hideWhileLoading ? (
                    this.props.isLoading ? (
                        <BeatLoader
                            color="#5341c6"
                            loading={this.props.isLoading}
                            cssOverride={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                            }}
                        />
                    ) : (
                        this.props.children
                    )
                ) : (
                    <Fragment>
                        {this.props.isLoading && (
                            <BeatLoader
                                color="#5341c6"
                                loading={this.props.isLoading}
                                cssOverride={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            />
                        )}
                        {this.props.children}
                    </Fragment>
                )}
            </div>
        );
    }
}

LoadingIndicator.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    children: PropTypes.node,
    isFullscreen: PropTypes.bool,
    hideWhileLoading: PropTypes.bool,
};

export default LoadingIndicator;
